import { enqueueSnackbar } from "notistack";
import ModalContainer from "../../common/ModalContainer";
import BusinessDocument from "../../ProfileSurvey/New/BusinessDocument";
import updateUsersProfile from "../../../controllers/user/updateUsersProfile";

const CustomerDetailUploadDocModal = ({
  open,
  setOpen,
  data,
  reload,
  setLoading,
  loading,
  callback,
}) => {
  async function handleDocUpload(payload) {
    setLoading?.(true);
    const res = await updateUsersProfile(data?._id, payload).finally(() => {
      setLoading?.(false);
    });
    if (res.return) {
      enqueueSnackbar("Documents Uploaded", { variant: "success" });
      setOpen(false);
      callback?.(res?.data);
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
    return res.return;
  }

  return (
    <>
      <ModalContainer open={open} setOpen={setOpen} title="Upload Document">
        <BusinessDocument
          updateProfile={handleDocUpload}
          next={() => console.log("callback")}
          user={data}
        />
      </ModalContainer>
    </>
  );
};

export default CustomerDetailUploadDocModal;
